<template>
    <div>
        <textarea v-model="text" :maxlength="maxLength" :readonly="readOnly" rows="10" style="width: 100%; padding-left: 5px;" :style="readOnly ? { background: '#e9eaec' } : { background: '#f8f9f9' }"></textarea>
        <span style="font-size: 10px">Limitare MySMIS: {{ limit ? limit : 0 }} caractere. ( {{ remaining }} de caractere rămase )</span>
    </div>
</template>

<script>
    import { charactersRemaining } from "@/helpers/helpers";

    export default {
        name: "CFTextarea",

        props: {
            limit: {
                required: true,
                default: null,
                type: Number
            },
            value: {
                required: false,
                default: null,
                type: String
            },
            readOnly: {
                required: false,
                default: null,
                type: Boolean
            },
        },
        data () {
            return {
                text: '',
                remaining: 0,
                maxLength: 1000,
            }
        },
        watch: {
            text: {
                handler: function () {
                    let response = charactersRemaining(this.text, this.limit, true)
                    this.remaining = response.limit;
                    this.maxLength = this.limit - response.diacriticsUsed;
                    if(this.remaining < 0){
                        this.text = this.text.substring(0, this.text.length - 1);
                    }
                    this.$emit('input', this.text);
                }
            },
            value: {
                handler: function () {
                    this.text = this.value
                }
            }
        },
        mounted() {
            this.remaining = charactersRemaining(this.text, this.limit);
            this.maxLength = this.limit;
            this.text = this.value
        },
    }
</script>

<style scoped>
    textarea {
        overflow: auto;
        outline: none;

        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        resize: none;
        border: 2px solid #9da2b0;
        border-radius: 5px;
    }
</style>
